export default __webpack_public_path__ + "ubisoft-playtest-profile-icon-person-running-black.webp";